<template>
	<b-table
		class="RoutesTable"
		checkable
		:is-row-checkable="isRowCheckable"
		:checked-rows.sync="checkedRows"
		hoverable
		paginated
		backend-pagination
		:data="routes"
		:columns="columns"
		:loading="isLoading"
		:empty="!isLoading && total === 0"
		:total="total"
		:per-page="perPage"
		backend-sorting
		default-sort-direction="desc"
		:default-sort="[sortParams.field, sortParams.order]"
		@page-change="changePage"
		@sort="changeSortParams"
		@update:checkedRows="$emit('update:checkedRows', $event)"
	>
		<template slot-scope="props">
			<!-- <b-table-column field="id">{{ props.row.id }}</b-table-column> -->

			<b-table-column field="name">
				<a href @click.prevent="$emit('route-click', props.row)" class="route-link">
					<span
						:style="`background-color: ${getColorByName(props.row.color).hex};`"
						class="route-color-preview"
						v-if="props.row.color"
					></span>
					<!-- <i class="no-route-color" v-else>-- brak --</i> -->
					<span class="route-name">{{ props.row.name }}</span>
				</a>
			</b-table-column>

			<b-table-column field="orders" class="nowrap" :visible="currentTab !== 'new'">{{
				props.row.orders.length
			}}</b-table-column>

			<b-table-column field="createdDate">
				<div v-if="props.row.createdDate">
					{{ props.row.createdDate | humanDate }}
					<small>{{ props.row.createdDate | date('DD/MM/YYYY') }}</small>
				</div>
				<span v-else>-</span>
			</b-table-column>
		</template>
		<template slot-scope="props" slot="header">
			{{ props.column.label }}
			<i
				v-show="sortParams.field === props.column.field"
				:class="{ mdi: true, 'is-desc': sortParams.order === 'desc' }"
				>arrow_upward</i
			>
		</template>
		<template slot="empty">
			<section class="section">
				<div class="content has-text-grey has-text-centered">
					<p>
						<b-icon icon="emoticon-sad" size="is-large"></b-icon>
					</p>
					<p>Brak tras.</p>
				</div>
			</section>
		</template>
		<template slot="bottom-left">
			<div class="per-page">
				<span>Wyświetlaj rekordów:</span>
				<b-select @input="changePerPage($event)" :value="perPage">
					<option
						v-for="(value, index) in perPageOptions"
						:key="index"
						:value="value"
						:selected="value === perPage"
					>
						{{ value }}
					</option>
				</b-select>
			</div>
		</template>
	</b-table>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import bus from '@/EventBus'
import config from '@/config'
import { getColorByName } from '@/helpers'
import RouteService from '@/services/RouteService'

export default {
	data() {
		return {
			routes: [], // current loaded
			checkedRows: [],
			perPage: localStorage.getItem('routes-table-per-page') || 10,
			perPageOptions: config.company.perPageOptions,
			pageNr: 1,
			sortParams: {
				field: 'createdDate',
				order: 'desc'
			},
			total: 0,
			isLoading: false,
			filter: {}
		}
	},
	computed: {
		...mapState('orders', ['currentTab', 'searchText']),
		columns() {
			return [
				// {
				// 	field: 'id',
				// 	label: 'NR',
				// 	sortable: true
				// },
				{
					field: 'name',
					label: 'Trasa',
					sortable: true
				},
				{
					field: 'order',
					label: 'Liczba zamówień',
					visible: this.currentTab !== 'new'
				},
				{
					field: 'createdDate',
					label: 'Dodano',
					sortable: true
				}
			]
		}
	},
	methods: {
		isRowCheckable(route) {
			let isCheckable = false
			if (!route.orders.length) return false
			route.orders.forEach((order) => {
				if (order.lat && order.lon) isCheckable = true
			})
			return isCheckable
		},
		getColorByName(hex) {
			return getColorByName(hex)
		},
		changePage(pageNr) {
			this.pageNr = pageNr
			this.loadRoutes()
		},
		changePerPage(num) {
			this.perPage = num
			localStorage.setItem('routes-table-per-page', this.perPage)
			this.loadRoutes()
		},
		changeSortParams(field, order) {
			this.sortParams = { field, order }
			this.loadRoutes()
		},
		loadRoutes() {
			this.isLoading = true
			RouteService.getAll(this.sortParams, this.perPage, this.pageNr, this.filter, this.searchText)
				.then((res) => this.loadRoutesSuccess(res.data))
				.catch((err) => this.loadRoutesFailure(err))
		},
		loadRoutesSuccess(data) {
			this.routes = []
			this.total = data['hydra:totalItems']
			if (this.total / this.perPage > 1000) {
				this.total = this.perPage * 1000
			}
			this.isLoading = false
			if (this.total === 0) return false
			data['hydra:member'].forEach((item) => {
				this.routes.push(item)
			})
			this.checkedRows = []
			bus.$emit('routes-loaded')
		},
		loadRoutesFailure(err) {
			this.routes = []
			this.isLoading = false
			throw { error: err }
		}
	},
	filters: {
		date(value, format) {
			return moment(value).format(format)
		},
		humanDate(value) {
			return moment(value).fromNow()
		}
	},
	created() {
		moment.locale('pl')
		bus.$on('tab-change', () => {
			if (this.currentTab === 'new') return
			// this.filter = { by: 'status', value: this.currentTab }
			this.filter = this.currentTab !== 'all' ? { by: 'status', value: this.currentTab } : null
			this.loadRoutes()
		})

		this.events = [
			'order-created',
			'order-updated',
			'order-archived',
			'order-unarchived',
			'order-accepted',
			'order-trashed',
			'order-complaint',
			'order-duplicated',
			'order-deleted',
			'route-attached',
			'route-detached',
			'route-updated',
			'route-archived',
			'route-deleted',
			'search'
		]
		bus.$once(this.events, () => {
			this.loadRoutes()
		})
		bus.$on(['change-view-mode', 'routes-loaded'], () => {
			this.checkedRows = []
		})
	},
	destroyed() {
		bus.$off('tab-change')
		bus.$off(this.events)
	}
}
</script>

<style lang="scss" scoped>
td.nowrap {
	white-space: nowrap;
}
[data-label='Dodano'] {
	small {
		display: block;
		font-size: 11px;
		color: #aaa;
	}
}
.route-link {
	& > * {
		vertical-align: middle;
	}
}
.route-color-preview {
	width: 20px;
	height: 20px;
	display: inline-block;
	margin: 5px 5px 0;
	border: 1px solid #ccc;
	border-radius: 3px;
}
.per-page {
	> span {
		margin-right: 10px;
		vertical-align: middle;
	}
	> div {
		display: inline-block;
		vertical-align: middle;
	}
}
</style>
